export { Man as default } from './Man';
